import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

export default function CustomChart(props) {
  const { lineChartData, unit } = props;
  const totalNumData = lineChartData.length;

  const xAxisTime = [
    lineChartData[0]["jsTime"],
    lineChartData[Math.ceil(totalNumData / 6)]["jsTime"],
    lineChartData[Math.ceil((2 * totalNumData) / 6)]["jsTime"],
    lineChartData[Math.ceil((3 * totalNumData) / 6)]["jsTime"],
    lineChartData[Math.ceil((4 * totalNumData) / 6)]["jsTime"],
    lineChartData[Math.ceil((5 * totalNumData) / 6)]["jsTime"],
    lineChartData[totalNumData - 1]["jsTime"],
  ];

  const lineKeys = Object.keys(lineChartData[0]).filter(key => key !== "jsTime");
  const brightColors = [
    "#FF5733", "#5733FF", "#FFD700", "#FF33A1", "#33A1FF",
    "#A1FF33", "#FF8C33", "#8C33FF", "#FF4500", "#8CFF33"
  ];

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        data={lineChartData}
        margin={{ top: 0, right: 0, left: 0, bottom: 0 }}  // No margins
      >
        <CartesianGrid strokeDasharray="3 3" />
        
        <XAxis
          dataKey="jsTime"
          ticks={xAxisTime}
          tick={{ fontSize: 10 }} 
        />
        
        <YAxis
          unit={unit}
          tick={{ fontSize: 10 }} 
        />

        <Tooltip
          contentStyle={{ fontSize: 10 }} 
          itemStyle={{ fontSize: 10 }}
        />

        <Legend
          wrapperStyle={{ fontSize: 10 }} 
        />

        {lineKeys.map((key, index) => (
          <Line
            key={index}
            type="monotone"
            dataKey={key}
            stroke={key === "total" ? "#000000" : brightColors[index % brightColors.length]}
            dot={false}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
}
